import React from 'react'
import LxPanel from '@/components/LxPanel';
// import { NavLink } from 'react-router-dom'
import { navList }  from '../../../constants';
import { getNavApi } from '@/api'

class NavItem extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            navAll: []
        }
    }
    componentDidMount() {
        getNavApi().then(res => {
            this.setState({
                navAll: [...navList, ...res.data]
            })
        })
    }
    render() {
        return (
            <ul className="lx-flex-row">
                {
                    this.state.navAll.map((item, index) => {
                        return (
                            <li className="lx-flex-shrink-0" key={index}>
                                {
                                    item.linkedTarget === '_blank'? (
                                        <a className="lx-flex-row" href={item.linkedUrl} target={item.linkedTarget}>
                                            <span className="title">{ item.name }</span>
                                        </a>
                                    ):(
                                        // <NavLink exact className="lx-flex-row" to={item.linkedUrl} target={item.linkedTarget}>

                                        <a className="lx-flex-row" href={item.linkedUrl} target={item.linkedTarget}>
                                            <span className="title">{ item.name }</span>
                                            {
                                                item.childList && item.childList.length > 0 ? (
                                                    <div className="subNav">
                                                        <LxPanel list={item.childList}></LxPanel>
                                                    </div>
                                                ) : ''
                                            }
                                        </a>
                                    )
                                }
                            </li>
                        )
                    })
                }
            </ul>
        )
    }
}

export default NavItem;